import { Box, Center, Grid, Text } from "@chakra-ui/react";
import React from "react";

export const PricingDetailRow = ({
  label,
  value1,
  value2,
  value3,
  hideBorder = false,
}: {
  label: string;
  value1: string | React.ReactNode;
  value2: string | React.ReactNode;
  value3: string | React.ReactNode;
  hideBorder?: boolean;
}) => {
  return (
    <Grid
      gridTemplateColumns={"1fr 2fr 2fr 2fr"}
      overflowX="auto"
      flex={1}
      gap={4}
      w="full"
      mb={2}
      py={2}
      minW="900px"
      borderBottom={hideBorder ? "none" : "1px solid"}
      borderColor="brand.1000"
      color="brand.1000"
    >
      <Box>
        <Text fontWeight={600} color="brand.1000">
          {label}
        </Text>
      </Box>
      <Center textAlign="center">{value1}</Center>
      <Center textAlign="center">{value2}</Center>
      <Center textAlign="center">{value3}</Center>
    </Grid>
  );
};
